import React, { useState } from "react"
import { toast } from "react-toastify"
import isEmpty from "validator/lib/isEmpty"
import isIP from "validator/lib/isIP"
import { useHistory, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { FaSave } from "react-icons/fa"
import { v4 as uuidv4 } from "uuid"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isInKioskMode } from "utils"
import { Button, } from "components"
import { addPrinter, editPrinter } from "@redux"
import classes from "./PrinterSaveButton.module.scss"

const PrinterSaveButton = props => {
  const {
    form,
    editMode,
    printerCategoryIds,
    setFormErrors,
    setPrinterIndex,
    initialFormErrorsState,
    previousPrinterVariables
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const { numberOfPrinters } = useParams()

  const printers = useSelector(state => state.printers)

  const accountId =
    useSelector(state => state.userAccountInfo.accountId)

  const [sending, setSending] = useState(false)

  const validate = () => {
    const errors = { ...initialFormErrorsState }
    let result = true

    const printerNameExists =
      !editMode &&
      printers.some(printer =>
        printer.printerName === form.printerName
      )

    if (isEmpty(form.printerName)) {
      errors.printerName = t("اسم_پرینتر_الزامی_است")
      result = false
    } else if (form.printerName.length > 100) {
      errors.printerName = t("اسم_پرینتر_طولانی_است")
      result = false
    } if (printerNameExists) {
      errors.printerName = t("اسم_پرینتر_تکراری_است")
      result = false
    }

    if (form.printerModal === "thermal") {
      if (form.printerInterface === "tcp") {
        if (isEmpty(form.ipAddress)) {
          errors.ipAddress = t("Ip_پرینتر_اجباری_است")
          result = false
        } else if (!isIP(form.ipAddress)) {
          errors.ipAddress = t("Ip_پرینتر_صحیح_نیست")
          result = false
        }

        if (!!form.localPrintServerIpAddress && !isIP(form.localPrintServerIpAddress)) {
          errors.ipAddress = t("آدرس_Ip_سرور_پرینتر_محلی_صحیح_نیست")
          result = false
        }
      }

      if (form.printerInterface === "usb") {
        if (!form.deviceName) {
          errors.deviceName = t("پرینتری_انتخاب_نشده")
          result = false
        }
      }

      if (isEmpty(form.printerType)) {
        errors.printerType = t("نوع_پرینتر_الزامی_است")
        result = false
      }
    }

    if (form.printerModel !== "thermal") {
      if (!form.deviceName) {
        errors.deviceName = t("پرینتری_انتخاب_نشده")
        result = false
      }
    }

    setFormErrors({ ...errors })

    return result
  }

  const handleEdit = async () => {
    if (!validate()) return

    setSending(true)

    const newPrinter = { ...form, printerCategoryIds }

    previousPrinterVariables.current = newPrinter

    const changedPrinter = {
      ...form,
      _id: form.printerId,
      accountId,
      port: 9100,
      categoryIds: Object.keys(printerCategoryIds)
    }

    try {
      dispatch(
        editPrinter(
          form.printerId,
          changedPrinter
        )
      )

      toast.success(t("پرینتر_ویرایش_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("پرینتر_با_موفقیت_ویرایش_نشد"))
    }

    setSending(false)
  }

  const handleAdd = async () => {
    if (!validate()) return

    setSending(true)

    previousPrinterVariables.current = {
      ...form,
      printerCategoryIds
    }

    const newPrinter = {
      _id: uuidv4(),
      ...form,
      accountId,
      port: 9100,
      categoryIds: Object.keys(printerCategoryIds)
    }

    try {
      dispatch(
        addPrinter(newPrinter)
      )

      setPrinterIndex(numberOfPrinters - 1)

      history.push(
        kioskMode ? "/kiosk-settings" : "/settings",
        { initialTab: "printers" }
      )

      toast.success(t("پرینتر_ذخیره_شد"))
    } catch (err) {
      console.log(err)
      toast.error(t("پرینتر_با_موفقیت_ذخیره_نشد"))
    }

    setSending(false)
  }

  const kioskMode = isInKioskMode()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Button
      color="success"
      className={classes["save"]}
      loading={sending}
      onClick={editMode ? handleEdit : handleAdd}
    >
      <FaSave
        color="white"
        size={18}
      />
      <span
        className={clsx(
          classes["test-text"],
          isLtr && classes["test-text-ltr"]
        )}
      >
        {t("ذخیره")}
      </span>
    </Button>
  )
}


export default PrinterSaveButton